import { INTERNAL_TAGS, LEGACY_INTERNAL_TAGS } from '@/const/message';

function getTagVariants(tagName: string) {
  const normalizedTagName = tagName.trim();
  if (!normalizedTagName) {
    return [];
  }

  return [...new Set([
    normalizedTagName,
    normalizedTagName.replace(/-/g, '_'),
  ])];
}

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * 过滤消息中的内部标签及其内容。
 * 额外标签用于调用方根据场景补充需要隐藏的标签。
 */
export function filterInternalTags(content: string, additionalTags: string[] = []): string {
  const tagNames = [...INTERNAL_TAGS, ...LEGACY_INTERNAL_TAGS, ...additionalTags];
  return tagNames.reduce((result, tagName) => {
    return getTagVariants(tagName).reduce((nextResult, variant) => {
      const escapedVariant = escapeRegExp(variant);
      const tagRegex = new RegExp(`<${escapedVariant}\\b[^>]*>[\\s\\S]*?</${escapedVariant}>`, 'g');
      return nextResult.replace(tagRegex, '');
    }, result);
  }, content);
}
